import React, { useRef, useEffect, useMemo, useState } from 'react';
import DataGrid, { Column, Editing, GroupPanel, Lookup, Paging } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, Label, SimpleItem, ButtonItem, FormRef } from "devextreme-react/form";
import IJournal from "../../models/IJournal";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import useMessageType from "../../components/selectbox/type-message";
import FormSysteme from '../../components/forms/form-systeme';
import { useContextPopupPage } from "../../components/popups/PopupPage";
import useLookUpBase from '../../components/selectbox/LookupBase';
import PopupFermeturesModules from "./popup-fermetures-modules";
import './journal.css';
import { maxWidth } from 'devexpress-reporting/scopes/reporting-chart-internal';
import IGestionJournal from '../../models/IGestionJournal';
import IGrandLivre from '../../models/IGrandLivre';
import GestionFolios from '../gestion-folios/gestion-folios';
import useApi from '../../hooks/useApi';

interface IGrandLivreJournalProps {
  isModeSelection?: boolean
}

export default function GrandLivreJournal({ isModeSelection }: IGrandLivreJournalProps) {
  const reservationDataSourceOption: IFormBaseDataSourceOptions<IGestionJournal> = useMemo(() => ({
    path: "journal",
    customReadByIdPath: "journal/{key}/gestion",
    customSauvegarderPath: "journal/save",
    primaryKey: "idJournal",
  }), []);

  const journalFormDataSource = useCustomDataSource<IJournal, IGestionJournal>(reservationDataSourceOption);
  // const journalFormDataSource = useCustomDataSource<IJournal, IJournal>({ path: "journal", primaryKey: "idJournal" });
  const { setMainForm, selectedDataRow: selectedJournal, mode, setSelectedDataRow, setMode, isFieldModifier, setIsFieldModifier, onFieldDataChanged } = journalFormDataSource;
  // const { MessageTypeSelectBox, messageTypeEditorOptions, currentMessageType } = useMessageType()
  const { editorOptions: folioOptions, PopupGestion: PopupGestionFolio } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "folio", showClear: mode !== Mode.Lecture });
  const formRef = useRef<FormRef>(null);
  // const detailsDataSource = useCustomDataSource<IGrandLivre, IGrandLivre>({ path: "grandLivre", primaryKey: "idGrandLivre" });
  const dataGridFilterValue = useMemo(() => ["isDeleted", "anyof", [null, false]], []);
  const { selectedValue, setSelectedValue } = useContextPopupPage();
  const [isPopupReserverOpen, setIsPopupReserverOpenState] = useState(false);
  const [recettes, setRecettes] = useState({ debit: '', credit: '', ecart: '' });

  const setDataRow = (e: string) => {
    // setSelectedDataRow((prev: IJournal) => (
    //   { ...prev, [e]: Guid.empty.toString() }
    // ));
    setIsFieldModifier(true);
  }

  const readOnlyOptions = useMemo(() => {
    return {
      readOnly: true,
      width: '75px',
      value: 21
    }
  }, []);

  const dateTransactionEditorOptions = useMemo(() => {
    return {
      width: '125px',
    }
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  useEffect(() => {
    if (selectedJournal?.journalDetail) {
      let debit = 0;
      let credit = 0;
      selectedJournal.journalDetail.forEach(e => {
        if (!e.isDeleted) {
          if (e.montant > 0)
            debit += e.montant;
          else
            credit += e.montant;
        }
      });
      let ecart = debit + credit;
      setRecettes({ debit: `${debit},00$`, credit: `${credit},00$`, ecart: `${ecart},00$` });
    }
  }, [selectedJournal?.journalDetail]);

  return (
    <FormListBase key={"frm-messages"} data={journalFormDataSource}>
      <FormListBaseGrid
        dataSource={journalFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture)
          }
        }}
        onRowDoubleClick={(e: any) => {
          if (setSelectedValue && e.data.idMessage)
            setSelectedValue(e.data.idMessage)
        }}>
        <Column key={"grid-col-no-dossier"} dataField={"noDossier"} caption="No dossier" allowHiding={false}>
        </Column>
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
        <Column key={"grid-col-dateTransaction"} dataField={"dateTransaction"} caption="Date transaction" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`Dossier # ${selectedJournal?.noDossier || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          {isPopupReserverOpen && <PopupFermeturesModules isPopupOpen={isPopupReserverOpen} onClose={() => setIsPopupReserverOpenState(false)}
          // onReserver={(ajoutReservationOption) => {
          //   setAjoutReservationOptions(ajoutReservationOption);
          //   setIsPopupReservationOpenState(true)
          // }}
          />}
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedJournal || {} as IJournal} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <PopupGestionFolio onSelectionchanged={() => {
              }}>
                <GestionFolios isModeSelection={true} />
              </PopupGestionFolio>
              <GroupItem colCount={2} cssClass='journal-max-width'>
                <GroupItem>
                  <SimpleItem key={"frm-noDossier"} dataField={"noDossier"}
                    render={() => <span>{selectedJournal?.noDossier}</span>}
                  >
                    <Label text={"No. de dossier"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-reference"} dataField={"description"}>
                    <Label text={"Référence"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-date-transaction"} dataField={"dateTransaction"} editorType={"dxDateBox"} editorOptions={dateTransactionEditorOptions}>
                    <Label text={"Date de transaction"} />
                  </SimpleItem>
                </GroupItem>
                <GroupItem>
                  <SimpleItem key={"frm-debit-total"}
                    editorOptions={readOnlyOptions}
                    render={() => <span>{recettes.debit}</span>}
                  >
                    <Label text={"Débit total"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-credit-total"}
                    editorOptions={readOnlyOptions}
                    render={() =>
                      <span style={{ color: recettes.credit ? 'red' : 'black' }}>
                        {recettes.credit}
                      </span>}
                  >
                    <Label text={"Crédit total"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-ecart"}
                    editorOptions={readOnlyOptions}
                    render={() => <span>{recettes.ecart}</span>}
                  >
                    <Label text={"Écart"} />
                  </SimpleItem>
                </GroupItem>
              </GroupItem>
              <GroupItem caption='Détails'>
                <DataGrid
                  showBorders={true}
                  dataSource={selectedJournal.journalDetail}
                  allowColumnReordering={true}
                  // onCellPrepared={cellPrepared}
                  onInitNewRow={() => ({} as IGrandLivre)}
                  filterValue={dataGridFilterValue}
                  onRowRemoving={async (e) => {
                    e.cancel = true;
                    // if (e?.data?.idPermisType) {
                    const index = selectedJournal.journalDetail.findIndex(item =>
                      item.idGrandLivre?.equals(e.data.idGrandLivre)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedJournal.journalDetail];
                      updatedData[index] = { ...updatedData[index], isDeleted: true };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        journalDetail: updatedData
                      }));
                    }
                    // }
                  }}
                  onRowUpdating={(e: any) => {
                    const index = selectedJournal.journalDetail.findIndex(item =>
                      item.idGrandLivre?.equals(e.oldData.idGrandLivre)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedJournal.journalDetail];
                      updatedData[index] = { ...updatedData[index], ...e.newData };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        journalDetail: updatedData
                      }));
                      setIsFieldModifier(true);
                    }
                  }}
                // onRowRemoving={async (e) => {
                //   e.cancel = true;
                //   console.log(e)
                //   if (e?.data?.idGrandLivre) {
                //     try {
                //       // await postData(
                //       //   { Guid: e.data.idGrandLivre },
                //       //   `journal/deleteGrandLivre`,
                //       //   true
                //       // );
                //       await getData({ customPath: `journal/${e.data.idGrandLivre}/DeleteJournalDetail` });

                //       const updatedData = selectedJournal.journalDetail.filter(
                //         item => item.idGrandLivre !== e.data.idGrandLivre
                //       );

                //       setSelectedDataRow(prev => ({
                //         ...prev,
                //         journalDetail: updatedData
                //       }));
                //     } catch (error) {
                //       console.error('Error deleting row:', error);
                //     }
                //   }
                // }}
                // onRowUpdated={(e: any) => {
                //   console.log(e)
                //   setSelectedDataRow((prev) => {
                //     console.log("Previous state:", prev);
                //     return {
                //       ...prev,
                //       journalDetail: [
                //         ...prev.journalDetail,
                //         {
                //           ...e.data,
                //           credit: e.data.credit ?? 0,
                //           debit: e.data.debit ?? 0,
                //         },
                //       ],
                //     };
                //   });
                //   // setSelectedDataRow(prev => ({..prev, prev.jourd }))
                // }}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={mode !== Mode.Lecture}
                    allowDeleting={mode !== Mode.Lecture}
                    allowAdding={mode !== Mode.Lecture}
                    newRowPosition={"first"}
                    startEditAction={"click"} />
                  <GroupPanel visible={false} />
                  <Column dataField="idFolio" dataType="string" alignment="left" caption={"Folio"}
                  >
                    <Lookup {...folioOptions} />
                  </Column>
                  <Column dataField="description" dataType="string" caption={"Description"} />
                  <Column dataField="montant" dataType="number" caption={"Débit"} format="#,##0.00 $" />
                  <Column dataField="numeroRemise" dataType="number" caption={"Crédit"} format="#,##0.00 $" />
                  <Column dataField="isDeleted" dataType="boolean" visible={false} />
                </DataGrid>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedJournal || {} as IJournal} /></TabItem>
        </FormListBaseTab> : null
      }
    </FormListBase>
  );
}